import { mailgunService } from '../../libraries';

const sendWelcomeEmail = async (userEmail: string, userPassword: string) => {
  const emailHtml = `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        body {
          font-family: Arial, sans-serif;
          background-color: #f4f4f4;
          margin: 0;
          padding: 0;
        }
        .email-container {
          max-width: 600px;
          margin: 20px auto;
          background: #ffffff;
          border: 1px solid #dddddd;
          border-radius: 8px;
          overflow: hidden;
        }
        .header {
          background-color: #007bff;
          color: white;
          text-align: center;
          padding: 20px 10px;
          font-size: 20px;
          font-weight: bold;
        }
        .content {
          padding: 20px;
          color: #333333;
          line-height: 1.6;
        }
        .content h1 {
          font-size: 22px;
          color: #007bff;
          margin-bottom: 10px;
        }
        .content p {
          margin-bottom: 10px;
        }
        .credentials {
          background-color: #f9f9f9;
          padding: 10px 15px;
          border-radius: 4px;
          margin-top: 10px;
        }
        .credentials p {
          margin: 5px 0;
        }
        .footer {
          background-color: #f4f4f4;
          color: #666666;
          text-align: center;
          font-size: 12px;
          padding: 10px;
          border-top: 1px solid #dddddd;
        }
      </style>
    </head>
    <body>
      <div class="email-container">
        <div class="header">
          Welcome to the Body Miracle Portal!
        </div>
        <div class="content">
          <h1>Your Login Credentials</h1>
          <p>Welcome to the Body Miracle Portal! We're excited to have you on board!</p>
          <p> Here are your login credentials:</p>
          <div class="credentials">
            <p><strong>Email:</strong> ${userEmail}</p>
            <p><strong>Password:</strong> ${userPassword}</p>
          </div>
          <p>You can log in by clicking the button below:</p>
          <p style="text-align: center;">
            <a href="https://portal.bodymiracle.com/" style="display: inline-block; padding: 10px 20px; font-size: 16px; color: white; background-color: #007bff; text-decoration: none; border-radius: 4px;">Log In</a>
          </p>
          <p>If you have any questions, feel free to reach out to our support team.</p>
          <p>Cheers!</p>
        </div>
        <div class="footer">
          &copy; ${new Date().getFullYear()} Body Miracle. All rights reserved.
        </div>
      </div>
    </body>
    </html>
  `;

  const success = await mailgunService.sendEmail(
    userEmail,
    'Body Miracle Portal - Account Creation',
    `Welcome to Body Miracle! Your login credentials are ${userEmail}/${userPassword}`,
    emailHtml
  );

  return success;
};

export default sendWelcomeEmail;